import { Injectable } from '@angular/core';
import moment from 'moment';
import { map } from 'rxjs';

import { LoadTickets, LoadTicketsFail, LoadTicketsSuccess } from '../../store';
import { LineValuesKpi } from '../types';
import { ChartType } from '../types/chart-type.types';
import { ChartService } from './chart.service';

@Injectable()
export class CaseHistoryByDateChartService extends ChartService<LineValuesKpi> {
  public readonly chart$ = this.chartsDataLoader({
    request: LoadTickets,
    failure: LoadTicketsFail,
    success: LoadTicketsSuccess,
  }).pipe(
    map(({ loading, data }) => {
      type DataValue = LineValuesKpi['value'];

      let maxDate: moment.Moment = moment();
      let minDate: moment.Moment = moment();

      const groupedByDate: Record<string, 0> = {};

      (Array.isArray(data?.data) ? data?.data : []).forEach((ticket) => {
        const momentDate = moment(ticket.CreatedDate);
        minDate = moment.min(minDate, momentDate);
        maxDate = moment.max(maxDate, momentDate);

        const key = momentDate.format('YYYY/MM/DD');
        groupedByDate[key] ??= 0;
        groupedByDate[key] += 1;
      });

      let cursorDate = moment(minDate).add(-1, 'days');
      const dataValue: DataValue = Array.from(
        { length: moment(maxDate).diff(minDate, 'days') },
        () => {
          cursorDate = cursorDate.add(1, 'days');
          const label = cursorDate.format('YYYY/MM/DD');

          return {
            label,
            value: groupedByDate[label] || 0,
            hyperlink: '/tickets', // not clear if this is the correct link
          };
        },
      );

      return {
        ngClass: [],
        loading,
        data: {
          type: ChartType.LINE,
          id: 'Case history by date',
          title: 'Ticket history by date',
          value: dataValue.filter((s) => s.value),
        } satisfies LineValuesKpi,
      };
    }),
  );
}
